import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

export const TagsPageRoot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 11.25rem)",
  minHeight: 320,
  overflow: "hidden",
  boxSizing: "border-box",
}));

export const TagsTableFrame = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
});

export const TagTypeChipStyled = styled(Chip)(({ theme }) => ({
  fontWeight: 500,
}));

export const TagsLoadingRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const TagsLoadingLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const TagsReadOnlyCellText = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const TagsAliasPathText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$contextualized",
})(({ theme, $contextualized }) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  color: $contextualized
    ? theme.palette.text.primary
    : theme.palette.text.secondary,
  fontStyle: $contextualized ? "normal" : "italic",
}));

export const ToolbarClearFiltersButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  marginRight: theme.spacing(1),
}));
